import React from 'react';
import { strings } from 'src/localization/index';
import css from './DesktopDiagnoseModal.module.scss';
import SVPButton from 'src/components/SVPButtons/SVPButton';
import classNames from 'classnames';
import { diagnoseResponses } from '../../DiagnoseTreeLit/DiagnoseTreeLit';

interface IProps {
    selectedButton: string;
    responses: diagnoseResponses[];
    indexMapLength: number;
    cancelHandler: (e: any) => void;
    backHandler: (e: any) => void;
    nextHandler: (e: any) => void;
    addHandler: (value: string) => void;
    otherResponse: boolean;
    additionalComments: string;
    title: string;
    error: boolean;
    theme: string;
}

const DiagnoseModalFooter = (props: IProps) => {
    const noArrow = props.theme === 'porsche' ? true : false;
    const cancelButton = (
        <div className={css.normalBtn}>
            <SVPButton
                id='cancelBtn'
                message={strings.CancelButton}
                noArrow
                variant='secondaryBtnAlt'
                handler={props.cancelHandler}
                theme={props.theme}
            />
        </div>
    );

    const backButton = (
        <div className={css.normalBtn}>
            <SVPButton
                id='backBtn'
                message={strings.BackButton}
                backArrow={props.theme !== 'lexusMonogram'}
                variant='secondaryBtnAlt'
                handler={props.backHandler}
                theme={props.theme}
                noArrow={noArrow}
            />
        </div>
    );

    const nextButton = (
        <div className={css.normalBtn}>
            <SVPButton
                id='nextBtn'
                message={strings.NextButton}
                variant='primaryBtnAlt'
                handler={props.nextHandler}
                theme={props.theme}
                noArrow={noArrow}
            />
        </div>
    );

    const addButton = (
        <div className={css.addBtn}>
            <SVPButton
                id='addDiagnosisBtn'
                message={strings.AddDiagnosisButton}
                variant='primaryBtnAlt'
                plus
                noArrow
                isDisabled={props.error}
                handler={() => props.addHandler(props.otherResponse ? props.additionalComments : props.title)}
                theme={props.theme}
            />
        </div>
    );
    const classes = classNames(
        css.footer,
        {
            [css.footerNoPrimaryBtn]: (props.selectedButton || props.responses.length === 0),
        },
    );

    const footer = (
        <div className={classes}>
            {props.indexMapLength > 0 ? backButton : cancelButton}
            {props.selectedButton ? nextButton : null}
            {props.responses.length === 0 ? addButton : null}
        </div>
    );

    return footer;
};

export default DiagnoseModalFooter;
